import { Button } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import { IItemOption } from "../../../../interfaces";

import { DividerStyled } from "../../../../../../components/DividerStyled";

import './style.css'

interface IProps {
  option: IItemOption;
  selected: boolean;
  onClick: (value: IItemOption) => void;
}

export default function Option({
  option,
  selected,
  onClick,
}: IProps) {
  const showInformativeIcon = !!option?.description;
  const showDescription = showInformativeIcon && selected;

  return (
    <Button
      className="simulador-option-button"
      onClick={() => onClick(option)}
      disabled={option.next === "to-do"}
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
        maxWidth: "100%",
        background: option.next === "to-do" ? "#e6e6e6" : selected ? "#2D66A2" : "#FFFFFF",
        outline: 0,
        height: 'auto',
        whiteSpace: 'normal',
        borderRadius: 20,
        alignItems: 'flex-start',
        padding: showDescription ? '12px 15px' : '8px 15px',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            fontWeight: 400,
            color: selected ? "#FFFFFF" : "#2D66A2",
            whiteSpace: 'normal',
            lineHeight: 1.4,
            textAlign: 'left'
          }}
        >
          {option.text}
        </span>

        {
          showInformativeIcon && (
            <InfoCircleOutlined
              style={{
                fontSize: '1.1rem',
                marginLeft: 8,
                color: selected ? "#FFFFFF" : "#2D66A2"
              }}
            />
          )
        }
      </div>

      {
        showDescription && (
          <DividerStyled
            style={{
              width: "100%",
              margin: '8px 0',
              background: '#cccccc',
            }}
          />
        )
      }

      {
        showDescription && (
          <span
            style={{
              fontWeight: 400,
              color: "#FFFFFF",
              whiteSpace: 'normal',
              lineHeight: 1.4,
              textAlign: 'left',
            }}
          >
            {option.description}
          </span>
        )
      }
    </Button>
  )
}
